import React, { useMemo } from "react";
import { TableListing } from "../../../../../components/AppListing/TableListing";
import { formatPhoneNumber } from "../../../../../utils/common_lib";
import ListIcon from "../../../../../components/listIcon";

function FacilityListing({
  nurses = [],
  nursesLoading = false,
  onEdit = () => {},
  onCheckInOut = () => {},
  onDelete = () => {},
  deletingNurse = false,
}) {

    const cols = useMemo(() => [
        {
            title: "Nurse Name",
            key: "name",
            colClass: "flex text-left",
            getData: (item) => item?.name || item?.username || "-",
        },
        {
            title: "Username",
            key: "username",
            colClass: "flex text-left",
            getData: (item) => item?.username || "-",
        },
        {
            title: "Email",
            key: "email",
            colClass: "flex text-left",
            getData: (item) => item?.email || "-",
        },
        {
            title: "Mobile Number",
            key: "phone",
            colClass: "flex text-left",
            getData: (item) => item?.phone || item?.mobile_number ? formatPhoneNumber(item?.phone || item?.mobile_number) : <p className="px-6">-</p>,
        },
        // {
        //     title: "Status",
        //     key: "status",
        //     colClass: "flex text-center",
        //     getData: (item) => `${item?.active !== false ? "Active" : "Inactive"}`,
        // },
        {
            title: "Admin",
            key: "is_facility_admin",
            colClass: "flex text-left",
            getData: (item) => (item?.is_facility_admin ? "Yes" : "No"),
        },
        {
            title: "Actions",
            key: "actions",
            colClass: "flex text-center justify-center items-center",
            align: "center",
            skipColHtmlTooltip: true,
            getData: (item) => {
                return (
                    <div className="flex gap-2 items-center justify-center h-[100%]">
                        <ListIcon
                            title="Edit"
                            handler={() => onEdit(item)}
                            type="edit"
                            disabled={deletingNurse}
                        />
                        <ListIcon
                            title="Check-in/Check-out"
                            handler={() => onCheckInOut(item)}
                            type="check-in"
                            disabled={deletingNurse}
                        />
                        <ListIcon
                            title="Delete"
                            handler={() => onDelete(item)}
                            type="remove"
                            disabled={deletingNurse}
                        />
                    </div>
                );
            },
        },
    ], [onEdit, onCheckInOut, onDelete, deletingNurse]);

    return (
        <div className="px-3 mt-2 w-full h-[calc(100vh-130px)] overflow-y-auto shadow-md">
            <TableListing
                listData={nurses || []}
                cols={cols || []}
                loading={nursesLoading || false}
            />
        </div>
    );
}

export default FacilityListing;
